module.exports = __webpack_public_path__ + "static/media/480.70469834.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-snail/light/480.png
// module id = 2450
// module chunks = 2